module.exports = __webpack_public_path__ + "img/project10_7.jpg.64319c6a.webp";